<script setup lang="ts">
import { ModalDefault } from '@shared/ui/modals'
import { BtnPrimary, BtnSecondary } from '@shared/ui/buttons'

import { useModalTutorBillingNewAccount } from '../../model/modal-tutor-billing-new-account.hook'
import TutorBillingModalHeader from '../TutorBillingModalHeader.vue'
import TutorBillingFieldsTable from '../TutorBillingFieldsTable.vue'

defineOptions({
  name: 'ModalTutorBillingNewAccount',
})

const {
  isOpen,
  isSaving,
  subtitle,
  columns,
  rows,
  setClose,
  setDiscard,
  setAddToSalesforce,
} = useModalTutorBillingNewAccount()
</script>

<template>
  <ModalDefault
    :show="isOpen"
    :loading="isSaving"
    class-name="modal-tutor-billing-new-account"
    is-close-button
    @click:overlay="setClose"
    @click:close="setClose"
  >
    <TutorBillingModalHeader
      title="New billing info submitted"
      :subtitle="subtitle"
    />
    <TutorBillingFieldsTable
      :columns="columns"
      :rows="rows"
    />
    <template #controls>
      <BtnPrimary
        text="Add to Salesforce"
        color="emerald"
        :disabled="isSaving"
        @click="setAddToSalesforce"
      />
      <BtnSecondary
        text="Discard info"
        :disabled="isSaving"
        @click="setDiscard"
      />
    </template>
  </ModalDefault>
</template>

<style scoped lang="scss" src="./ModalTutorBillingNewAccount.scss" />
